import { SvgIcon, SvgIconProps } from "@mui/material";

export const AllReviewsBackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};
